import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import MobileCTA from "@/components/layout/MobileCTA";

export const Layout = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="flex min-h-screen flex-col" data-testid="site-layout">
      <Header />
      <main className="flex-1 pb-20 md:pb-0" data-testid="main-content">
        <Outlet />
      </main>
      <Footer />
      <MobileCTA />
    </div>
  );
};

export default Layout;
